"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TestPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const testService_1 = require("@/service/testService");
const react_1 = require("react");
function TestPage() {
    (0, react_1.useEffect)(() => {
        //test();
    }, []);
    const test = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield (0, testService_1.getDatasetResult)();
            console.log(response);
            if (response) {
                const resultSet = response.results[0].tables[0].rows;
                console.log("rows:", resultSet);
            }
        }
        catch (error) {
            const serviceError = error;
            console.log(serviceError);
        }
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("button", { className: "m-8 p-2 border-solid border-2 border-sky-500", onClick: test, children: "Run" }) }));
}
